$(document).ready(function () {
   "use strict";

    var $win = $(window);
    var $box = $(".bannerCurtainWrap .wrapper");

    $win.on("click.Bst", function(event){

        if ($box.has(event.target).length == 0 && !$box.is(event.target) && $('body').hasClass('searchCurtainActive') && !$(event.target).hasClass('js_openCurtain')) {
            event.preventDefault();
            $('body').removeClass('searchCurtainActive');
            $('html').removeClass('noScroll');
        }
    });

    $('.js_openCurtain').on('click', function(e) {
        e.preventDefault();
        $('html').addClass('noScroll');
        $('body').addClass('searchCurtainActive');
    });

    $('.js_bannerCurtainClose, .js_bannerCurtainCloseButton').on('click', function(e) {
        e.preventDefault();
        $('body').removeClass('searchCurtainActive');
        $('html').removeClass('noScroll');

        if ($(this).hasClass('button')) {
            $('html, body').animate({
                scrollTop: $('.fullSearchPage').offset().top - 20
            }, 1000);
        }
    });

    if (matchesMediaQuery(0, 900)) {
        $('.js_bannerCurtainCloseButton').waypoint(function(direction) {

            if (direction == 'down') {
                $('.curtainBanner').addClass('stickTop');
            } else if (direction == 'up') {
                $('.curtainBanner').removeClass('stickTop');
            }
        }, {
            offset: 0
        });
    }

    if ($('.js_curtainCtas').length) {

        if (matchesMediaQuery(0, 670)) {

            $('.js_curtainCtas').slick({
                arrows: false,
                dots: true,
                speed: 300,
                infinite: true,
                autoplay: true,
                autoplaySpeed: 2000,
                customPaging: function(slider, i) {
                    return '<button type="button" data-role="none" role="button" aria-required="false" tabindex="0">' + (i + 1) + '</button>';
                },
            });
        }
    }
});